<template>
  <!-- <div>
    <div class="record-primary">
      {{ data[primary[0].dataField] }}
    </div>
    <div v-for="item in secondaryItems" :key="item" class="record-secondary">
      {{ item }}
    </div>
  </div> -->

  <div class="gc-record" style="display: flex">
    <div class="image-cell" v-if="hasImage">
      <div class="gc-list-record-icon-img" v-if="false">
        <!-- HasPrimaryImage -->
        <img :src="imgUrl" />
      </div>
      <div class="gc-list-record-icon">
        <!-- v-else -->
        {{ data.data[primary[0].dataField].charAt(0) }}
      </div>
    </div>
    <div class="gc-grid-item-container">
      <div class="gc-grid-description">
        {{ data.data[primary[0].dataField] }}
      </div>
      <!-- <div class="gc-grid-code">{{ ItemCode }}</div> -->
      <div
        v-for="(item, index) in secondaryItems"
        :key="index"
        class="record-secondary gc-grid-code"
      >
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    primary: {
      type: Array,
    },
    secondary: {
      type: Array,
    },
    showImage: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      hasImage: this.showImage,
      // data: {
      //   CustomerName: "Udara Sandesha",
      //   CustomerCode: "01",
      //   CustomerCode2: "02",
      //   CustomerCode3: "03",
      //   CustomerCode4: "04",
      // },
      // primary: [{ dataField: "CustomerName", position: "append" }],
      // secondary: [
      //   { dataField: "CustomerCode", position: "append" },
      //   { dataField: "CustomerCode2", position: "append" },
      //   { dataField: "CustomerCode3", position: "append" },
      //   { dataField: "CustomerCode4", position: "append" },
      // ],
    };
  },
  computed: {
    secondaryItems() {
      let secondaryArr = [];
      let str = "";
      this.secondary.forEach((el, i) => {
        if (el.position === "below") {
          if (str) {
            secondaryArr.push(str);
            str = "";
          }
          if (
            i == this.secondary.length - 1 ||
            (this.secondary[i + 1] !== undefined &&
              this.secondary[i + 1].position === "below")
          )
            secondaryArr.push(this.data.data[el.dataField]);
          else str = str + this.data.data[el.dataField];
        } else if (el.position === "append" || !el.position) {
          str = str
            ? str + " " + this.data.data[el.dataField]
            : this.data.data[el.dataField];
          if (i == this.secondary.length - 1) {
            secondaryArr.push(str);
            str = "";
          }
        }
      });
      return secondaryArr;
    },
  },
  created() {
    // if (this.data.column)
    //   if (this.data.column.cellTemplateRecord)
    //     if (this.data.column.cellTemplateRecord.image) this.hasImage = true;

  },
};
</script>

<style lang="scss" scoped>
.record-primary {
  font-size: 12px;
  text-align: left;
  max-height: 2.4em;
  line-height: 1.2;
  overflow: hidden;
}
.record-secondary {
  font-size: 10px;
  text-align: left;
  color: grey;
}

.image-cell {
  margin-right: 10px;
}

.gc-list-record-icon {
  flex-basis: 33.5px;
  width: 33.5px;
  max-width: 33.5px;
  min-width: 33.5px;
  height: 33.5px;
  line-height: 33.5px;
  text-align: center;
  background-color: #20a4da;
  color: #ffffff;
  font-size: 15px;
  text-transform: uppercase;
  border: 1px solid #20a4da;
  border-radius: 50%;
  margin-left: 5px;
  overflow: hidden;
}
.gc-list-record-icon-img {
  flex-basis: 33.5px;
  width: 33.5px;
  max-width: 33.5px;
  min-width: 33.5px;
  height: 33.5px;
  line-height: 33.5px;
  text-align: center;
  color: white;
  font-size: 18px;
  border-radius: 50%;
  margin-left: 5px;
  overflow: hidden;
}

.gc-list-record-icon-img img {
  max-width: 33.5px;
  min-height: 33.5px;
}

.gc-grid-description {
  font-size: 14px;
  text-align: left;
  max-height: 2.4em;
  line-height: 1.2;
  overflow: hidden;
}
</style>
